import { ValuationStep } from '@/interfaces/valuation/ValuationStep'

export type ValuationStepData =
  | PropertyValuationStepData
  | BuildingValuationStepData
  | LocalityValuationStepData
  | UnitValuationStepData
  | {}

/**
 * Property Type
 */
import { PropertyType } from '@/interfaces/valuation/types/PropertyValuationStep'
export interface PropertyValuationStepData {
  propertyType: PropertyType
}
export const PropertyValuationStepProperties = ['propertyType']

/**
 * Building Information
 */
import {
  BuildingStatus,
  BuildingType,
  BuildingAge,
  BuildingReconstruction,
} from '@/interfaces/valuation/types/BuildingValuationStep'
export interface BuildingValuationStepData {
  buildingStatus: BuildingStatus
  buildingType?: BuildingType
  buildingAge?: BuildingAge
  buildingReconstruction?: BuildingReconstruction
}
export const BuildingValuationStepProperties = [
  'buildingStatus',
  'buildingType',
  'buildingAge',
  'buildingReconstruction',
]

/**
 * Locality
 */
import {
  LocationType,
  Location,
  LocationDistrictProperties,
  LocationAddressProperties,
  LocationGpsProperties,
  LocationProjectProperties,
} from '@/interfaces/valuation/types/LocalityValuationStep'
export interface LocalityValuationStepData {
  locationType: LocationType
  location: Location | undefined
}
export const LocalityValuationStepProperties = {
  [LocationType.District]: LocationDistrictProperties,
  [LocationType.Address]: LocationAddressProperties,
  [LocationType.GPS]: LocationGpsProperties,
  [LocationType.Project]: LocationProjectProperties,
}

/**
 * Unit
 */
import {
  ApartmentUnit,
  HouseUnit,
  ApartmentUnitProperties,
  HouseUnitProperties,
} from '@/interfaces/valuation/types/UnitValuationStep'
export interface UnitValuationStepData {
  unit: ApartmentUnit | HouseUnit
  propertyPrice: number
}
export const UnitValuationStepProperties = {
  [PropertyType.Flat]: ApartmentUnitProperties,
  [PropertyType.House]: HouseUnitProperties,
}

/**
 * ValuationData
 */
export default interface ValuationData {
  previousStep: ValuationStep | undefined
  currentStep: ValuationStep
  nextStep: ValuationStep | undefined
  steps: ValuationStep[]
  parentValuationId: number | null
}
